import { usePackageFormValidation } from '../../../../hooks/packages/usePackageFormValidation';
import { useSavePackage } from '../../../../hooks/packages/useSavePackage';
import Loading from '../../../ui/Loading';
import NewPackageDetails from '../common/NewPackageDetails';
import NewPackageSelectedItems from '../common/NewPackageSelectedItems';

interface NewPackageDataProps {
    typOfAction: "newPackage" | "updatePackage"
}

export default function NewPackageData({ typOfAction }: NewPackageDataProps) {

    const { 
        handleSavePackage, 
        isLoadingCreatePackage,
        isLoadingUpdatePackageDetails,
        isLoadingUpdatePackageItems,
        isLoadingCreateNewPackageItems,
        isLoadingUpdateSpecialPackageDetails,
        isLoadingUpdateSpecialPackageItems
    } = useSavePackage({typOfAction})
    const { isSubmitDisabled } = usePackageFormValidation({typOfAction})
    const isDisabled = [isLoadingUpdateSpecialPackageDetails, isLoadingUpdateSpecialPackageItems, isSubmitDisabled, isLoadingCreatePackage, isLoadingCreateNewPackageItems].some(Boolean);
    const isUpdatingPackage = isLoadingUpdatePackageDetails || isLoadingUpdatePackageItems;
    const isRunning = isLoadingCreatePackage || isUpdatingPackage;
    const isDisableBtn = isRunning || isDisabled;
    const btnMessage = isLoadingCreatePackage ? 'Saving package...' : isUpdatingPackage ? 'Updating package...' : ''
    
    return (
        <>
            <NewPackageDetails typOfAction={typOfAction}/>
            <NewPackageSelectedItems typOfAction={typOfAction}/>
            <button 
                // disabled={isDisableBtn}
                onClick={handleSavePackage}
                className={`w-full text-sm px-4 py-2 rounded font-medium transition-all ${isDisableBtn ? 'cursor-not-allowed bg-gray-200 border text-black' : 'bg-cbColor text-white'}`}
            >
                {isRunning ? (
                    <Loading setH={'h-[20px]'} message={btnMessage} />
                ) : (
                    <>
                        {typOfAction === 'newPackage' && 'Save New Package'}
                        {typOfAction === 'updatePackage' && 'Save Updated Package'}
                    </>
                )}
            </button> 
        </>
    )
}
